import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { SelectedEventArgs } from '@syncfusion/ej2-angular-inputs';
import { EmitType } from '@syncfusion/ej2-base';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { HCSplValidationService } from '../../shared/services/hc-spl-validation.service';
import { ISplValidationHC } from '../../shared/models/spl-validation-hc.model';
import { ToastrService } from 'ngx-toastr';
import { IApiResult } from '../../shared/models/api-result';
import { ISplMessageHC } from '../../shared/models/spl-message-hc.model';
import { GridComponent, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { SettingsService } from '../../shared/services';
import { Tooltip } from '@syncfusion/ej2-popups';
import { fadeInOut } from '../../shared/helpers/animations';

@Component({
  selector: 'app-health-canada-spl-validation',
  templateUrl: './health-canada-spl-validation.component.html',
  styleUrls: ['./health-canada-spl-validation.component.scss'],
  animations: [fadeInOut],
})
export class HealthCanadaSplValidationComponent implements OnInit {

  // ------------------------------------------------------------
  // Page state
  // ------------------------------------------------------------
  pageState: string = null;

  // ------------------------------------------------------------
  // SPL Validation
  // ------------------------------------------------------------
  @Input() splErrorMessages: ISplMessageHC[];
  public uploadStatus = '';
  public validationStatus = '';
  public validationFileName = '';
  public validationStatusClassName = '';
  public isHideErrorsWarnings = false;
  public clipmodecolumn = {class: 'e-tooltipcolumn'};
  @ViewChild('tooltip', {static: true})
  public tooltipObj: TooltipComponent;
  @ViewChild('validationGrid')
  public errorGrid: GridComponent;
  uploadSaveUrl: string;

  constructor(
    public hcSplValidationService: HCSplValidationService,
    private authService: AuthenticationService,
    private toastr: ToastrService,
    private settingsService: SettingsService
  ) {
  }

  ngOnInit(): void {
    this.pageState = this.hcSplValidationService.PAGE_STATE_READY;
    this.uploadSaveUrl = this.hcSplValidationService.getFileUploadUrl();
    this.initTabIndex();
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById("firstDiv");

    if (main) {
      main.focus();
    }
  }

  private resetPage() {
    this.validationStatus = '';
    this.validationFileName = '';
    this.uploadStatus = '';
    this.splErrorMessages = [];
  }

  // ------------------------------------------------------------
  // File upload
  // ------------------------------------------------------------

  public onFileUploadStart: EmitType<SelectedEventArgs> = (args: any) => {
    this.resetPage();
    if (args) {
      const authData = this.authService.getAuthData();

      args.currentRequest.setRequestHeader('authorization', this.authService.getBearerToken());
      args.currentRequest.setRequestHeader('customerGuid', this.settingsService.getCustomerGuid());
      args.currentRequest.setRequestHeader('applicationVariantId', authData.applicationVariantId ? authData.applicationVariantId.toString() : '');

      if (!args.cancel) {
        this.pageState = this.hcSplValidationService.PAGE_STATE_UPLOADING;
      }
    }
  }

  public onFileUploadedSuccess: EmitType<Object> = (args: any) => {
    this.pageState = this.hcSplValidationService.PAGE_STATE_READY;
    this.uploadStatus = 'Uploaded Successfully';

    const apiResult = JSON.parse(args.e.currentTarget.response) as IApiResult;
    const splValidation = apiResult.data as ISplValidationHC;

    this.validationFileName = args.file.name;
    this.splErrorMessages = splValidation.messages as ISplMessageHC[];
    this.setValidationStatus(splValidation.validationStatus);
  }

  public onUploadFailure(args: any): void {
    this.pageState = this.hcSplValidationService.PAGE_STATE_READY;
    this.setValidationStatus('Fail');
    this.uploadStatus = 'Upload Failed - Please try to upload the file again';
  }

  private setValidationStatus(validationStatus: string) {
    this.validationStatus = validationStatus;
    this.validationStatusClassName = `validation-${validationStatus?.toLocaleLowerCase()}`;
  }

  // ------------------------------------------------------------
  // Validation Table
  // ------------------------------------------------------------

  tooltipValue(args) {
    let grid;

    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {

      grid = this.errorGrid;

      const rowInfo = grid.getRowInfo(args.target);
      const rowData = rowInfo.rowData;
      this.tooltipObj.content = rowData[(rowInfo.column as any).field];
    }
  }

  customiseCell(args: QueryCellInfoEventArgs) {

    if (args.data['messageType'] === 'Error') {
      args.cell.classList.add('customcssError');
    } else if (args.data['messageType'] === 'Warning') {
      args.cell.classList.add('customcssWarning');
    }

    if (args.column.field === 'fieldName') {
      const tooltip: Tooltip = new Tooltip({
        content: args.data['fieldName'].toString()
      }, args.cell as HTMLTableCellElement);
    }
  }

  showHideErrorsWarnings() {
    this.isHideErrorsWarnings = !this.isHideErrorsWarnings;
  }
}
